import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';
import { formBuilderUrl, issueTypeConfigurationUrl, requestTypeConfigurationUrl } from '@atlassian/proforma-common-core/jira-common-utils';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

import { messages } from './messages';
export const getMessage = (formValidationResult, formDetails, projectKey, projectType, isSimplifiedProject, templateFormId, intl, push, createAnalyticsEvent, userIsProjectAdmin = false) => {
  let title;
  let description;
  let analyticsReason;
  const actions = [];
  if (userIsProjectAdmin) {
    actions.push({
      content: /*#__PURE__*/React.createElement(FormattedMessage, messages.conflictEditFormLinkLabelForProjectAdmin),
      onClick: () => push(formBuilderUrl(projectKey, projectType, isSimplifiedProject, templateFormId))
    });
  }
  if (formValidationResult.missing.length > 0) {
    var _formDetails$requestT, _formDetails$requestT2;
    const field = formValidationResult.missing[0];
    title = intl.formatMessage(messages.conflictMissingTitle);
    description = intl.formatMessage(userIsProjectAdmin ? messages.conflictMissingDescriptionForProjectAdmin : messages.conflictMissingDescriptionForNonProjectAdmin, {
      jiraFieldName: field.jiraFieldName,
      typeName: (_formDetails$requestT = (_formDetails$requestT2 = formDetails.requestType) === null || _formDetails$requestT2 === void 0 ? void 0 : _formDetails$requestT2.name) !== null && _formDetails$requestT !== void 0 ? _formDetails$requestT : formDetails.issueType.name
    });
    analyticsReason = 'missing';
  } else if (formValidationResult.isConditionallyShown.length > 0) {
    var _formDetails$requestT3, _formDetails$requestT4;
    const field = formValidationResult.isConditionallyShown[0];
    title = intl.formatMessage(messages.conflictIsConditionalTitle);
    description = intl.formatMessage(userIsProjectAdmin ? messages.conflictIsConditionalDescriptionForProjectAdmin : messages.conflictIsConditionalDescriptionForNonProjectAdmin, {
      formFieldName: field.proFormaQuestionLabel,
      jiraFieldName: field.jiraFieldName,
      typeName: (_formDetails$requestT3 = (_formDetails$requestT4 = formDetails.requestType) === null || _formDetails$requestT4 === void 0 ? void 0 : _formDetails$requestT4.name) !== null && _formDetails$requestT3 !== void 0 ? _formDetails$requestT3 : formDetails.issueType.name
    });
    analyticsReason = 'isConditionallyShown';
    if (userIsProjectAdmin) {
      let href;
      if (formValidationResult.requestTypeId !== undefined) {
        href = requestTypeConfigurationUrl(projectKey, projectType, isSimplifiedProject, formValidationResult.requestTypeId);
      } else if (formValidationResult.issueTypeId !== undefined) {
        href = issueTypeConfigurationUrl(projectKey, projectType, isSimplifiedProject, formValidationResult.issueTypeId);
      }
      actions.unshift({
        content: /*#__PURE__*/React.createElement(FormattedMessage, messages.conflictIsConditionalActionForProjectAdmin),
        href
      });
    }
  } else if (formValidationResult.needToBeMandatory.length > 0) {
    var _formDetails$requestT5, _formDetails$requestT6;
    const field = formValidationResult.needToBeMandatory[0];
    title = intl.formatMessage(messages.conflictNeedsToBeMandatoryTitle);
    description = intl.formatMessage(userIsProjectAdmin ? messages.conflictNeedsToBeMandatoryDescriptionForProjectAdmin : messages.conflictNeedsToBeMandatoryDescriptionForNonProjectAdmin, {
      formFieldName: field.proFormaQuestionLabel,
      jiraFieldName: field.jiraFieldName,
      typeName: (_formDetails$requestT5 = (_formDetails$requestT6 = formDetails.requestType) === null || _formDetails$requestT6 === void 0 ? void 0 : _formDetails$requestT6.name) !== null && _formDetails$requestT5 !== void 0 ? _formDetails$requestT5 : formDetails.issueType.name
    });
    analyticsReason = 'needToBeMandatory';
  }
  if (title && description) {
    fireTrackAnalytics(createAnalyticsEvent({}), `${ActionSubject.FORM_VALIDATION} ${Action.STOPPED}`, {
      stopReason: analyticsReason
    });
    return {
      title,
      description,
      actions
    };
  }
  return undefined;
};